function T3TableFiltersSearchInfo({ data }) {

    //console.log("TableDataBootstrap, data, isFetching", data);

    const columns = [
        { header: 'Nro', key: 'id', width: 23, visible: true },
        { header: 'Filtros', key: 'key', width: 23, visible: true },
        { header: 'Cuenta', key: 'countids', width: 23, visible: true },
    ];

    return (
        <div>
            <div className="text-start">
                <strong>Tabla: SearchInfo, Filtros más buscados por módulo:</strong>
            </div>
            <div className="table-responsive">
                <table className="table table-bordered">
                    <thead>
                        <tr className=''>
                            {data && data.length > 0 && columns && columns.length > 0 && (
                                columns.map((item, index) => {
                                    return (
                                        <th className=''>{item.header}</th>
                                    )
                                })
                            )}
                        </tr>
                    </thead>
                    <tbody>

                        {/* Start Table Body Columns */}
                        {data && data.length > 0 && (
                            data.map((item, index) => {
                                return (
                                    <tr key={index} className=''>

                                        <td className="list-table-cell-50"> {index+1} </td>
                                        <td className="list-table-cell-400"> {item.key} </td>
                                        <td className="list-table-cell-100"> {item.countids} </td>
                                    </tr>
                                )
                            })
                        )}
                        {/* End Table Body Columns */}

                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default T3TableFiltersSearchInfo